<template>
  <div>
    {{$t('text.cusMasterLayout.noAccess')}}
      <button @click="goToDashboard">{{$t('text.cusMasterLayout.dashboard')}}</button> 
  </div>
</template>

<script>
export default {
    methods: {
        goToDashboard() {
            let user = JSON.parse(localStorage.getItem("userDetails"));
            if(user.roles.includes('CompanyAdmin')) {
                this.$router.push({ name: 'companyDashboard'})
            } else if(user.roles.includes('Branch Manager')){
                  this.$router.push({ name: 'branchDashboard'})
            } else if(user.roles.includes('Customer') || user.roles.includes("Account Manager")){
                  this.$router.push({name: 'userDashboard'});
            } else if(user.roles.includes('IndustryManager')){
                this.$router.push({name: 'IndustrialBranchDashboard'});
            }
        }
    }
}
</script>

<style>

</style>